import { render } from "./GalleryClient.vue?vue&type=template&id=4dce0645"
import script from "./GalleryClient.vue?vue&type=script&lang=js"
export * from "./GalleryClient.vue?vue&type=script&lang=js"
script.render = render

export default script